var _defs, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDccomics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dccomcis",
    className: "feature__background",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "dcpattern",
    className: "tile1",
    patternUnits: "userSpaceOnUse",
    height: 200,
    width: 300,
    y: 0,
    x: 0,
    patternTransform: "scale(0.5) rotate(-10)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262244",
    d: "M54.5,0C24.4,0,0,24.4,0,54.5S24.4,109,54.5,109c30.1,0,54.5-24.4,54.5-54.5S84.6,0,54.5,0z M4,54.5         c0-5.9,1-11.6,2.9-17l5.2,3.6v40.9c-1.6-2.5-3-5.1-4.2-7.9C5.3,67.9,4,61.3,4,54.5z M90.2,90.2c-4.6,4.6-10,8.3-16,10.8         c-6.2,2.6-12.8,4-19.7,4c-6.8,0-13.4-1.3-19.7-4c-6-2.5-11.4-6.2-16.1-10.8c-1.5-1.5-2.8-3-4.1-4.6h27.9l11-8V34.3l-11-8.2H12.7         c1.8-2.6,3.8-5.1,6.1-7.4c4.6-4.6,10-8.3,16.1-10.8c6.2-2.6,12.8-4,19.7-4c6.8,0,13.4,1.3,19.7,4c6,2.5,11.4,6.2,16,10.8         c2.3,2.3,4.3,4.7,6.1,7.4h-8l-1.8,4l-5.3-4H68.8l-10.9,8.2v43.3l10.9,8h25.5C93,87.2,91.7,88.7,90.2,90.2z M23.3,39.8h10         c2.8,0,5.1,2.3,5.1,5.1v22.4c0,2.8-2.3,5.1-5.1,5.1h-6V42.7L23.3,39.8z M98.1,79.9V64.5H84v7.8h-6.1c-2.7,0-4.8-2.2-4.8-4.8V42.7         l-4-2.9H84v8.5H97l2.6-16.6c0.5,1,1,2.1,1.5,3.2c2.6,6.2,4,12.8,4,19.7c0,6.8-1.3,13.4-4,19.7C100.2,76.1,99.2,78.1,98.1,79.9z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dcpattern2",
    className: "tile1",
    patternUnits: "userSpaceOnUse",
    height: 200,
    width: 300,
    y: 100,
    x: 150,
    patternTransform: "scale(0.5) rotate(-10)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262244",
    d: "M54.5,0C24.4,0,0,24.4,0,54.5S24.4,109,54.5,109c30.1,0,54.5-24.4,54.5-54.5S84.6,0,54.5,0z M4,54.5         c0-5.9,1-11.6,2.9-17l5.2,3.6v40.9c-1.6-2.5-3-5.1-4.2-7.9C5.3,67.9,4,61.3,4,54.5z M90.2,90.2c-4.6,4.6-10,8.3-16,10.8         c-6.2,2.6-12.8,4-19.7,4c-6.8,0-13.4-1.3-19.7-4c-6-2.5-11.4-6.2-16.1-10.8c-1.5-1.5-2.8-3-4.1-4.6h27.9l11-8V34.3l-11-8.2H12.7         c1.8-2.6,3.8-5.1,6.1-7.4c4.6-4.6,10-8.3,16.1-10.8c6.2-2.6,12.8-4,19.7-4c6.8,0,13.4,1.3,19.7,4c6,2.5,11.4,6.2,16,10.8         c2.3,2.3,4.3,4.7,6.1,7.4h-8l-1.8,4l-5.3-4H68.8l-10.9,8.2v43.3l10.9,8h25.5C93,87.2,91.7,88.7,90.2,90.2z M23.3,39.8h10         c2.8,0,5.1,2.3,5.1,5.1v22.4c0,2.8-2.3,5.1-5.1,5.1h-6V42.7L23.3,39.8z M98.1,79.9V64.5H84v7.8h-6.1c-2.7,0-4.8-2.2-4.8-4.8V42.7         l-4-2.9H84v8.5H97l2.6-16.6c0.5,1,1,2.1,1.5,3.2c2.6,6.2,4,12.8,4,19.7c0,6.8-1.3,13.4-4,19.7C100.2,76.1,99.2,78.1,98.1,79.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dcgradient",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1,
    gradientTransform: "rotate(-45)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#344eab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00ccb1"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#dcgradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "rect",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#dcpattern)",
    opacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "rect",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#dcpattern2)",
    opacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDccomics);
export default __webpack_public_path__ + "static/media/dccomics.177dfd7b20f99b8d5418be6afbba9bb5.svg";
export { ForwardRef as ReactComponent };